import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
/**
 * Shown in place of a portal step when the contract behind it is no longer open — today that means
 * the customer has rejected the quote. Hiding the buttons was not enough: these are public routes,
 * so the step could still be reached by URL or by the browser's back button.
 *
 * The /contract page is deliberately not covered by this. It has its own "Bedankt voor je reactie"
 * message, which is the right thing to show someone who has just rejected a quote.
 */
export const PortalContractUnavailable = () => {
    const { t: translate } = useTranslation();
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: 2,
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 6, sm: 8, md: 10 }
        }, children: [_jsx(Typography, { sx: {
                    fontSize: { xs: 20, sm: 24, md: 28 },
                    fontWeight: 600
                }, children: translate("Deze pagina is niet meer beschikbaar") }), _jsx(Typography, { sx: {
                    color: "#6C757D",
                    fontSize: { xs: 14, sm: 15, md: 16 }
                }, children: translate("Deze offerte is afgerond. Neem contact met ons op als u nog vragen heeft.") })] }));
};
